export default {
  menuData: {},
  detailedCategory: {},
  tempData: {},
  selectedDatas: {},
  combinedMenuData: {},
};
